import {
  commaFormat,
  toDateString,
  unixTimestampToStr,
  isValidDate,
  isValidUnixTimestamp,
  paddingDecimal
} from '@GUTIL/format'

export const toFixed = (num, decimal = 0) => {
  if (!num) return
  if (decimal > 0) {
    return parseFloat(num)
      .toFixed(decimal + 1)
      .slice(0, -1)
  } else {
    return parseFloat(num)
      .toFixed(decimal + 1)
      .slice(0, -1)
      .split('.')
      .join('')
  }
}

export const emptyFormat = val => {
  return val || '-'
}

/**
 * 數字轉成金錢格式
 * e.g., 1234567 -> 12,345.67
 * @param {Number|String} value
 * @param {Number} decimal
 */
export const priceFormat = (value, decimal = 2) => {
  return commaFormat(paddingDecimal(Number(value), decimal))
}

/**
 * 筆數格式
 * e.g., 1234 -> 1,234
 * @param {Number|String} value
 */
export const countFormat = value => {
  return commaFormat(Number(value))
}

/**
 * 百分比格式
 * e.g., 0.2345 -> 23.45%
 * @param {Number|String} value
 * @param {Number} decimal
 */
export const percentFormat = (value, decimal = 2) => {
  const val = paddingDecimal(Number(value) * 100, decimal)
  return (isNaN(val) ? '-' : val) + '%'
}

/**
 * 把 ISO 時間格式轉為 YYYY-MM-DD hh:ii
 * @param {String} value
 */
export const dateTimeFormat = value => {
  return isValidDate(value) ? toDateString(value) : '-'
}

/**
 * 把10位的timestamp轉成 YYYY-MM-DD hh:ii
 * @param {Number} value
 */
export const timestampFormat = (value, noData = '-', hasSec) => {
  return isValidUnixTimestamp(value)
    ? unixTimestampToStr(value, hasSec)
    : noData
}
